import React from "react";
import axios from "@/utils/myAxios";
import myUploadAxios from '@/utils/myUploadAxios'
import moment from "moment";
import Cookie from "js-cookie";
import { Link } from "react-router-dom";
import { tableSummaries, isMobileDevice } from "@/utils/utils";
import {
    Button,
    Table,
    Pagination,
    message,
    Modal,
    Select,
    Input,
    InputNumber,
    Form,
    Checkbox,
    DatePicker,
    Slider,
    Row,
    Alert,
    Upload,
    Radio,
    Icon,
} from "antd";
import { statusList4 } from "@/utils/constant";

/**
 * 禁用之前日期
 */
const disabledDate = (current) => {
    return current < moment().startOf("day");
};

// 表单数据
const formData = {
    name: undefined,
    order_num: undefined,
    hands: undefined,
    kinds: [1],
    methods: [1],
    level: [0, 0],
    ante: [0, 0],
    multiple: [0, 0],
    time_range: [moment().add(1, "days"), moment().add(2, "days")],
    bonus_point: undefined,
    bonus_ticket_id: undefined,
    bonus_ticket_amt: undefined,
};
const maxRangeNumber = 99999999
let timer
export default class ActivityDailyChallenge extends React.Component {
    state = {
        loading: false, // 是否加载中
        exportLoading: false, // 导出是否加载中
        recordLoading: false, // 记录是否加载中
        configLoading: false, // 配置是否加载中
        uploadConfigLoading: false, //上传配置是否加载中
        show: false, // 添加弹窗
        showImport: false, // 是否显示导入弹窗
        showImportAll: false, // 是否显示导入多个弹窗
        type: undefined, // 弹窗类型
        title: undefined, // 弹窗标题
        importTitle: undefined, // 导入标题
        importAllTitle: undefined, // 导入多个标题
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            status: undefined,
        },
        recordQueryParams: {
            // 记录查询参数
            page: 1,
            limit: 20,
            total: 0,
        },
        statusList: statusList4, // 状态列表
        formData: { ...formData }, // 表单数据
        importAllformData: { // 导入所有表单数据
            url: undefined,
        },
        uploadConfigFile: {}, // 上传的配置文件
        data: [], // 表格数据
        selectedData: {}, // 选中的表格数据
        configList: [], // 配置列表
        configData: {}, // 配置数据
        ticketList: [], // 门票
        playType: [ // 玩法类型
            { label: this.props.language["palyingType1"], value: 1 },
            { label: this.props.language["palyingType2"], value: 3 },
            { label: this.props.language["palyingType3"], value: 4 },
        ]
    };

    componentDidMount () {
        this.fetchData();
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/task/active_task_list", {
                params: {
                    ...this.state.queryParams,
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams, total: res.count || 0 },
                    data: res.data || [],
                });
            });
    };

    /**
     * 获取配置数据
     */
    fetchConfigData = () => {
        axios.get("/v1/api/activity_leader_board_conf").then((res) => {
            res.data.blinds = [
                ...res.data.blinds,
                {
                    bb: maxRangeNumber,
                }
            ]
            res.data.multiples = [
                ...res.data.multiples,
                maxRangeNumber,
            ]
            res.data.short_antes = [
                ...res.data.short_antes,
                maxRangeNumber,
            ]
            this.setState({
                configData: res.data || {},
            });
        });
    };

    /**
     * 获取门票
     */
    fetchTicketList = () => {
        axios.get("/v1/api/mtt/ticket/conf_list_for_activity").then((res) => {
            this.setState({
                ticketList: res.data || [],
            });
        });
    };

    /**
     * 获取任务列表
     */
    fetchConfigList = () => {
        // 轮询获取所有任务列表
        let page = 1
        let limit = 1000
        let isLoading = false
        let configList = []
        timer = setInterval(() => {
            if (isLoading) return
            isLoading = true
            axios.get("/v1/api/task/active_task_raw_list", {
                params: {
                    page,
                    limit,
                },
            }).then((res) => {
                page++
                res.data = res.data || []
                configList = configList.concat(res.data)
                isLoading = false
                if (res.data.length < limit) {
                    clearInterval(timer)
                    this.setState({ configLoading: false, configList })
                }
            })
        })
    };

    /**
     * 初始化表单数据
     */
    handleInitFormData = (item) => {
        this.formRef.props.form.resetFields();
        // 回显表单数据
        const newFormData = {
            name: item.name,
            order_num: item.order_num,
            hands: item.hands,
            kinds: item.kinds || [],
            methods: item.methods || [],
            level: (() => {
                if (JSON.stringify(item.kinds) === '[1]' || JSON.stringify(item.kinds) === '[4]' || JSON.stringify(item.kinds) === '[8]') {
                    return [
                        this.state.configData.blinds.findIndex(
                            (value) => value.bb === item.begin_level
                        ),
                        this.state.configData.blinds.findIndex(
                            (value) => value.bb === item.end_level
                        ),
                    ];
                } else {
                    return [0, 0];
                }
            })(),
            ante: (() => {
                if (JSON.stringify(item.kinds) === '[2]') {
                    return [
                        this.state.configData.short_antes.findIndex(
                            (value) => value === item.begin_level
                        ),
                        this.state.configData.short_antes.findIndex(
                            (value) => value === item.end_level
                        ),
                    ];
                } else {
                    return [0, 0];
                }
            })(),
            multiple: (() => {
                if (JSON.stringify(item.kinds) === '[6]') {
                    return [
                        this.state.configData.multiples.findIndex(
                            (value) => value === item.begin_level
                        ),
                        this.state.configData.multiples.findIndex(
                            (value) => value === item.end_level
                        ),
                    ];
                } else {
                    return [0, 0];
                }
            })(),
            time_range: [moment(item.begin_time * 1000), moment(item.end_time * 1000)],
            bonus_point: item.bonus_point,
            bonus_ticket_id: (() => {
                let ticket = this.state.ticketList.find(item2 => item2.id === item.bonus_ticket_id)
                if (ticket) {
                    return item.bonus_ticket_id
                } else {
                    return undefined
                }
            })(),
            bonus_ticket_amt: (() => {
                let ticket = this.state.ticketList.find(item2 => item2.id === item.bonus_ticket_id)
                if (ticket) {
                    return item.bonus_ticket_amt > 0 ? item.bonus_ticket_amt : 1
                } else {
                    return undefined
                }
            })(),
        };
        this.setState({
            formData: newFormData,
        }, () => {
            this.handelChangeReward()
        });
    };

    /**
     * 导入任务配置
     */
    handleImportTaskConfig = () => {
        this.importFormRef.props.form.validateFields((err, values) => {
            if (!err) {
                const formData = this.state.configList.find(
                    (item) => item.id === values.id
                );
                this.handleInitFormData(formData);
                message.success(this.props.language["importSuccessMessage"]);
                this.handleClose("importTask");
            }
        });
    };

    /**
     * 导入多个任务配置
     */
    handleImportAllMatchConfig = () => {
        this.importAllFormRef.props.form.validateFields((err, values) => {
            if (!err) {
                axios
                    .post("/v1/api/task/import_active_task_list", {
                        url: values.url,
                    })
                    .then((res) => {
                        if (res.code === 1) {
                            message.success(this.props.language["importSuccessMessage"]);
                            this.handleClose("importAllConfig");
                            this.fetchData()
                        }
                    });
            }
        });
    };

    /**
     * 上传任务配置
     */
    handleUploadConfig = ({ file }) => {
        this.setState({ uploadConfigLoading: true })
        myUploadAxios.post('/v1/api/upload/s3', { path: 'cms/union/match', file: file }).then((res) => {
            if (res.code === 200) {
                this.setState({ uploadConfigFile: file })
                this.importAllFormRef.props.form.setFieldsValue({ url: res.data })
            }
            this.setState({ uploadConfigLoading: false })
        })
    };

    /**
     * 添加，修改排序
     */
    handleAddOrEditOrder = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                if (this.state.type === 'addTask') {
                    // 添加
                    axios
                        .post("/v1/api/task/create_active_task", {
                            name: values.name,
                            order_num: values.order_num,
                            hands: values.hands,
                            kinds: values.kinds,
                            methods: values.methods,
                            begin_level: (() => {
                                if (JSON.stringify(values.kinds) === '[1]' || JSON.stringify(values.kinds) === '[4]' || JSON.stringify(values.kinds) === '[8]') {
                                    return this.state.configData.blinds[values.level[0]].bb
                                } else if (JSON.stringify(values.kinds) === '[2]') {
                                    return this.state.configData.short_antes[values.ante[0]]
                                } else if (JSON.stringify(values.kinds) === '[6]') {
                                    return this.state.configData.multiples[values.multiple[0]]
                                }
                            })(),
                            end_level: (() => {
                                if (JSON.stringify(values.kinds) === '[1]' || JSON.stringify(values.kinds) === '[4]' || JSON.stringify(values.kinds) === '[8]') {
                                    return this.state.configData.blinds[values.level[1]].bb
                                } else if (JSON.stringify(values.kinds) === '[2]') {
                                    return this.state.configData.short_antes[values.ante[1]]
                                } else if (JSON.stringify(values.kinds) === '[6]') {
                                    return this.state.configData.multiples[values.multiple[1]]
                                }
                            })(),
                            begin_time: parseInt(
                                new Date(values.time_range[0]).getTime() / 1000
                            ),
                            end_time: parseInt(new Date(values.time_range[1]).getTime() / 1000),
                            bonus_point: values.bonus_point,
                            bonus_ticket_id: values.bonus_ticket_id,
                            bonus_ticket_amt: values.bonus_ticket_amt,
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(this.props.language["createSuccessMessage"]);
                                this.fetchData();
                                this.handleClose('addTask');
                            }
                        });
                } else if (this.state.type === 'editOrder') {
                    // 编辑排序
                    axios
                        .patch(`/v1/api/task/set_active_task_order`, {
                            id: this.state.selectedData.id,
                            order_num: values.order_num
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(this.props.language["editSuccessMessage"]);
                                this.fetchData();
                                this.handleClose('addTask');
                            }
                        })
                }
            }
        });
    };

    /**
     * 发布、下线
     */
    handleOperation = (type, item) => {
        if (type === 'publish') {
            // 发布
            Modal.confirm({
                title: this.props.language["hint"],
                content: this.props.language["publishConfirm"],
                onOk: () => {
                    axios
                        .patch(`/v1/api/task/online_active_task/${item.id}`)
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(this.props.language["publishSuccessMessage"])
                                this.fetchData()
                            }
                        })
                }
            })
        } else if (type === 'offline') {
            // 下线
            Modal.confirm({
                title: this.props.language["hint"],
                content: this.props.language["offlineConfirm"],
                onOk: () => {
                    axios
                        .patch(`/v1/api/task/offline_active_task/${item.id}`)
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(this.props.language["offlineSuccessMessage"])
                                this.fetchData()
                            }
                        })
                }
            })
        }
    };

    /**
     * 改变奖励
     */
    handelChangeReward = () => {
        setTimeout(() => {
            let bonus_point = this.formRef.props.form.getFieldValue("bonus_point");
            let bonus_ticket_id = this.formRef.props.form.getFieldValue("bonus_ticket_id");
            let award
            if (bonus_point || bonus_ticket_id) {
                award = true
            } else {
                award = undefined
            }
            this.formRef.props.form.setFieldsValue({
                award: award,
            })
        })
    };

    /**
     * 显示弹窗
     */
    handleShow = (type, item) => {
        if (type === 'addTask') {
            // 新增任务
            this.fetchConfigData();
            this.fetchTicketList();
            this.setState({ show: true, type, title: this.props.language["createTask"], importTitle: this.props.language["importTask"] });
        } else if (type === 'editOrder') {
            // 编辑排序
            this.setState({ show: true, type, title: this.props.language["editOrder"], selectedData: { ...item }, formData: { ...formData } });
        } else if (type === "importTask") {
            // 导入任务
            this.setState({ showImport: true, configLoading: true })
            this.fetchConfigList()
        } else if (type === "importAllConfig") {
            // 导入多个任务配置
            this.setState({
                showImportAll: true,
                importAllTitle: this.props.language["importConfigFile"]
            });
        }
    };

    /**
     * 关闭弹窗
     */
    handleClose = (type) => {
        if (type === "addTask") {
            this.formRef.props.form.resetFields();
            this.setState({ show: false, formData: { ...formData } });
        } else if (type === "importTask") {
            this.importFormRef.props.form.resetFields();
            this.setState({ showImport: false });
        } else if (type === "importAllConfig") {
            this.importAllFormRef.props.form.resetFields();
            this.setState({ showImportAll: false });
        }
    };

    /**
     * 导出数据
     */
    handleExport = () => {
        this.setState({ exportLoading: true });
        axios
            .get("/v1/api/task/export_active_task_list", {
                params: {
                    ...this.state.queryParams,
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({ exportLoading: false });
                if (res.code === 1) {
                    message.success(this.props.language["exportSuccessMessage"]);
                    window.open(process.env.REACT_APP_API_URL + res.url);
                }
            });
    };

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination) => {
        this.setState(
            {
                queryParams: {
                    ...this.state.queryParams,
                    page: pagination.current,
                    limit: pagination.pageSize,
                },
            },
            () => this.fetchData()
        );
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value) => {
        this.setState({
            queryParams: { ...this.state.queryParams, page: 1, [key]: value },
        });
    };

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    status: undefined,
                },
            },
            () => {
                this.fetchData();
            }
        );
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        placeholder={this.props.language["statusPlaceholder"]}
                        value={this.state.queryParams.status}
                        onChange={(value) => this.handleSetQueryParamsData("status", value)}
                    >
                        {this.state.statusList.map((item, index) => (
                            <Select.Option value={item.value} key={index}>
                                {item.label}
                            </Select.Option>
                        ))}
                    </Select>
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                    <Button type="primary" ghost onClick={() => this.handleShow("addTask")}>
                        {this.props.language["createTask"]}
                    </Button>
                    <Button
                        type="primary"
                        ghost
                        onClick={() => this.handleShow("importAllConfig")}
                    >
                        {this.props.language["importConfigFile"]}
                    </Button>
                    <Button
                        type="default"
                        icon="arrow-down"
                        className="btn-yellow-ghost"
                        loading={this.state.exportLoading}
                        onClick={this.handleExport}
                    >
                        {this.props.language["exportExcel"]}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={{
                            showTotal: (total) =>
                                `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                            showQuickJumper: true,
                            showSizeChanger: true,
                            size: isMobileDevice() ? 'small' : '',
                            pageSizeOptions: ["10", "20", "30", "40"],
                            current: this.state.queryParams.page,
                            pageSize: this.state.queryParams.limit,
                            total: this.state.queryParams.total,
                        }}
                        loading={this.state.loading}
                        onChange={this.hanldeChangePage}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["taskId"]}
                            dataIndex="id"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["taskName"]}
                            dataIndex="name"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["taskSort"]}
                            dataIndex="order_num"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["status"]}
                            dataIndex=""
                            render={(item) =>
                                this.state.statusList.find(
                                    (item2) => item2.value == item.status
                                )
                                    ? this.state.statusList.find(
                                        (item2) => item2.value == item.status
                                    ).label
                                    : ""
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gameType"]}
                            dataIndex="game_kind"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["playingType"]}
                            dataIndex="game_type"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["levelRange"]}
                            dataIndex="level"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["startTime"]}
                            dataIndex="begin_time"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["endTime"]}
                            dataIndex="end_time"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["integral"]}
                            dataIndex=""
                            render={(item) => {
                                return Number(item.bonus_point) ? item.bonus_point : ''
                            }}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["mttTicket"]}
                            dataIndex=""
                            render={(item) => {
                                return item.bonus_ticket_id ? `${item.bonus_ticket_name}（${item.bonus_ticket_id}）${item.bonus_ticket_amt}` : ''
                            }}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["playBoradHandNumber"]}
                            dataIndex="hands"
                        />

                        <Table.Column
                            align="center"
                            title={this.props.language["operation"]}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : "right"}
                            width={280}
                            render={(item) => (
                                <>
                                    <Button
                                        type="primary"
                                        ghost
                                        onClick={() => this.handleShow("editOrder", item)}
                                    >
                                        {this.props.language["editOrder"]}
                                    </Button>
                                    <Button
                                        className="ml10 btn-green-ghost"
                                        disabled={item.status === 2 || item.status === 3 || item.status === 4}
                                        onClick={() => this.handleOperation('publish', item)}
                                    >
                                        {this.props.language["publish"]}
                                    </Button>
                                    <Button
                                        className="ml10"
                                        type="danger"
                                        ghost
                                        disabled={item.status === 1 || item.status === 5}
                                        onClick={() => this.handleOperation('offline', item)}
                                    >
                                        {this.props.language["offLine"]}
                                    </Button>
                                </>
                            )}
                        />
                    </Table>
                </div>

                {/* 表单内容 */}
                <FormModal
                    {...this.props}
                    visible={this.state.show}
                    type={this.state.type}
                    title={this.state.title}
                    importTitle={this.state.importTitle}
                    recordLoading={this.state.recordLoading}
                    recordQueryParams={this.state.recordQueryParams}
                    playType={this.state.playType}
                    configData={this.state.configData}
                    ticketList={this.state.ticketList}
                    statusList={this.state.statusList}
                    formData={this.state.formData}
                    handleShow={this.handleShow}
                    onOk={this.handleAddOrEditOrder}
                    onCancel={() => this.handleClose('addTask')}
                    handelChangeReward={this.handelChangeReward}
                    hanldeChangePage={this.hanldeChangePage}
                    wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                />

                {/* 导入任务表单弹窗 */}
                <ImprotFormModal
                    {...this.props}
                    loading={this.state.configLoading}
                    visible={this.state.showImport}
                    title={this.state.importTitle}
                    configList={this.state.configList}
                    onOk={this.handleImportTaskConfig}
                    onCancel={() => this.handleClose('importTask')}
                    wrappedComponentRef={(importFormRef) =>
                        (this.importFormRef = importFormRef)
                    }
                />

                {/* 导入多个任务表单弹窗 */}
                <ImprotAllFormModal
                    {...this.props}
                    visible={this.state.showImportAll}
                    title={this.state.importAllTitle}
                    uploadConfigLoading={this.state.uploadConfigLoading}
                    importAllformData={this.state.importAllformData}
                    uploadConfigFile={this.state.uploadConfigFile}
                    handleUploadConfig={this.handleUploadConfig}
                    onOk={this.handleImportAllMatchConfig}
                    onCancel={this.handleClose}
                    wrappedComponentRef={(importAllFormRef) => (this.importAllFormRef = importAllFormRef)}
                />
            </div>
        );
    }
}

/**
 * 表单内容
 */
const FormModal = Form.create({ name: "form_model" })(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator, getFieldValue, setFieldsValue } = this.props.form;
            return (
                <Modal
                    maskClosable={false}
                    width={600}
                    title={
                        <Row type="flex" align="middle" justify="space-between">
                            <div>
                                <span>{this.props.title}</span>
                            </div>
                            {this.props.type === "addTask" &&
                                <Button
                                    style={{ marginRight: isMobileDevice() ? 0 : 30, width: isMobileDevice() ? '100%' : 'auto' }}
                                    type="primary"
                                    ghost
                                    onClick={() => this.props.handleShow("importTask")}
                                >
                                    {this.props.importTitle}
                                </Button>
                            }
                        </Row>
                    }
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={this.props.onCancel}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: '70vh',
                        overflowY: "auto",
                    }}
                >
                    <div className="container-content">
                        {/* 新增 */}
                        {this.props.type === "addTask" && this.props.configData.games && (
                            <Form>
                                <Form.Item label={this.props.language["taskName"]}>
                                    {getFieldDecorator("name", {
                                        rules: [
                                            {
                                                required: true,
                                                message: this.props.language["taskNameVerify"],
                                            },
                                        ],
                                        initialValue: this.props.formData.name,
                                    })(
                                        <Input
                                            maxLength={60}
                                            allowClear
                                            placeholder={this.props.language["taskNamePlaceholder"]}
                                        />
                                    )}
                                </Form.Item>
                                <Form.Item label={this.props.language["taskSort"]}>
                                    {getFieldDecorator("order_num", {
                                        rules: [
                                            {
                                                required: true,
                                                message: this.props.language["taskSortVerify"],
                                            },
                                        ],
                                        initialValue: this.props.formData.order_num,
                                    })(
                                        <InputNumber
                                            precision={0}
                                            min={0}
                                            max={999999}
                                            placeholder={this.props.language["taskSortPlaceholder"]}
                                        />
                                    )}
                                </Form.Item>
                                <Form.Item label={this.props.language["playBoradHandNumber"]}>
                                    {getFieldDecorator("hands", {
                                        rules: [
                                            {
                                                required: true,
                                                message: this.props.language["playBoradHandNumberVerify"],
                                            },
                                        ],
                                        initialValue: this.props.formData.hands,
                                    })(
                                        <InputNumber
                                            precision={0}
                                            min={0}
                                            max={100000000}
                                            placeholder={this.props.language["playBoradHandNumberPlaceholder"]}
                                        />
                                    )}
                                </Form.Item>
                                <Form.Item label={this.props.language["gameType"]}>
                                    {getFieldDecorator("kinds[0]", {
                                        rules: [
                                            {
                                                required: true,
                                                message: this.props.language["gameTypeVerify"],
                                            },
                                        ],
                                        initialValue: this.props.formData.kinds[0],
                                    })(
                                        <Radio.Group>
                                            {this.props.configData.games.map((item, index) => (
                                                <Radio key={index} value={item.kind}>
                                                    {item.name}
                                                </Radio>
                                            ))}
                                        </Radio.Group>
                                    )}
                                </Form.Item>
                                {JSON.stringify(getFieldValue('kinds')) === '[1]' &&
                                    <Form.Item label={this.props.language["playingType"]}>
                                        {getFieldDecorator("methods[0]", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["playingTypeVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.methods[0],
                                        })(
                                            <Radio.Group>
                                                {this.props.playType.map((item, index) => (
                                                    <Radio key={index} value={item.value}>
                                                        {item.label}
                                                    </Radio>
                                                ))}
                                            </Radio.Group>
                                        )}
                                    </Form.Item>
                                }
                                {(JSON.stringify(getFieldValue('kinds')) === '[1]' ||
                                    JSON.stringify(getFieldValue('kinds')) === '[4]' ||
                                    JSON.stringify(getFieldValue('kinds')) === '[8]') &&
                                    <Form.Item
                                        label={
                                            <span>
                                                {this.props.language["levelRange"]}：
                                                {getFieldValue("level") ?
                                                    getFieldValue("level")[0] < this.props.configData.blinds.length - 1 ? this.props.configData.blinds[getFieldValue("level")[0]].bb / 100 : this.props.language["unlimited"]
                                                    :
                                                    this.props.configData.blinds[this.props.formData.level[0]].bb / 100
                                                }
                                                -
                                                {getFieldValue("level") ?
                                                    getFieldValue("level")[1] < this.props.configData.blinds.length - 1 ? this.props.configData.blinds[getFieldValue("level")[1]].bb / 100 : this.props.language["unlimited"]
                                                    :
                                                    this.props.configData.blinds[this.props.formData.level[1]].bb / 100
                                                }
                                            </span>
                                        }
                                    >
                                        {getFieldDecorator("level", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["levelRangeVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.level,
                                        })(
                                            <Slider
                                                dots
                                                range
                                                tipFormatter={(value) =>
                                                    value < this.props.configData.blinds.length - 1 ? this.props.configData.blinds[value].bb / 100 : this.props.language["unlimited"]
                                                }
                                                min={0}
                                                max={this.props.configData.blinds.length - 1}
                                            />
                                        )}
                                    </Form.Item>
                                }
                                {JSON.stringify(getFieldValue('kinds')) === '[2]' && (
                                    <Form.Item
                                        label={
                                            <span>
                                                {this.props.language["forewordRange"]}：
                                                {getFieldValue("ante") ?
                                                    getFieldValue("ante")[0] < this.props.configData.short_antes.length - 1 ? this.props.configData.short_antes[getFieldValue("ante")[0]] / 100 : this.props.language["unlimited"]
                                                    :
                                                    this.props.configData.short_antes[this.props.formData.ante[0]] / 100
                                                }
                                                -
                                                {getFieldValue("ante") ?
                                                    getFieldValue("ante")[1] < this.props.configData.short_antes.length - 1 ? this.props.configData.short_antes[getFieldValue("ante")[1]] / 100 : this.props.language["unlimited"]
                                                    :
                                                    this.props.configData.short_antes[this.props.formData.ante[1]] / 100
                                                }
                                            </span>
                                        }
                                    >
                                        {getFieldDecorator("ante", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["forewordRangeVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.ante,
                                        })(
                                            <Slider
                                                dots
                                                range
                                                tipFormatter={(value) =>
                                                    value < this.props.configData.short_antes.length - 1 ? this.props.configData.short_antes[value] / 100 : this.props.language["unlimited"]
                                                }
                                                min={0}
                                                max={this.props.configData.short_antes.length - 1}
                                            />
                                        )}
                                    </Form.Item>
                                )}
                                {JSON.stringify(getFieldValue('kinds')) === '[6]' &&
                                    <Form.Item
                                        label={
                                            <span>
                                                {this.props.language["multipleRange"]}：
                                                {getFieldValue("multiple") ?
                                                    getFieldValue("multiple")[0] < this.props.configData.multiples.length - 1 ? String(this.props.configData.multiples[getFieldValue("multiple")[0]] / 100) + this.props.language["double"] : this.props.language["unlimited"]
                                                    :
                                                    String(this.props.configData.multiples[this.props.formData.multiple[0]] / 100) + this.props.language["double"]
                                                }
                                                -
                                                {getFieldValue("multiple") ?
                                                    getFieldValue("multiple")[1] < this.props.configData.multiples.length - 1 ? String(this.props.configData.multiples[getFieldValue("multiple")[1]] / 100) + this.props.language["double"] : this.props.language["unlimited"]
                                                    :
                                                    String(this.props.configData.multiples[this.props.formData.multiple[1]] / 100) + this.props.language["double"]
                                                }
                                            </span>
                                        }
                                    >
                                        {getFieldDecorator("multiple", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["multipleRangeVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.multiple,
                                        })(
                                            <Slider
                                                dots
                                                range
                                                tipFormatter={(value) =>
                                                    value < this.props.configData.multiples.length - 1 ? String(this.props.configData.multiples[value] / 100) + this.props.language["double"] : this.props.language["unlimited"]
                                                }
                                                min={0}
                                                max={this.props.configData.multiples.length - 1}
                                            />
                                        )}
                                    </Form.Item>
                                }
                                <Form.Item label={this.props.language["timeRange"]}>
                                    {getFieldDecorator("time_range", {
                                        rules: [
                                            {
                                                required: true,
                                                message: this.props.language["timeRangeVerify"],
                                            },
                                        ],
                                        initialValue: this.props.formData.time_range,
                                    })(
                                        <DatePicker.RangePicker
                                            disabledDate={disabledDate}
                                            showTime={{ format: "HH:mm" }}
                                            format="YYYY-MM-DD HH:mm"
                                        />
                                    )}
                                </Form.Item>
                                <Form.Item
                                    label={this.props.language["award"]}
                                >
                                    {getFieldDecorator('award', {
                                        rules: [
                                            {
                                                required: true,
                                                message: this.props.getLanguage("awardPlaceholder", ''),
                                            },
                                        ],
                                    })(
                                        <></>
                                    )}
                                </Form.Item>
                                <Form.Item
                                    labelCol={{ span: 5 }}
                                    wrapperCol={{ span: 19 }}
                                    label={this.props.language["integral"]}
                                >
                                    {getFieldDecorator('bonus_point', {
                                        rules: [
                                            {
                                                required: false,
                                                message: this.props.language["integralVerify"],
                                            },
                                        ],
                                        initialValue: this.props.formData.bonus_point,
                                    })(
                                        <InputNumber
                                            min={0.01}
                                            max={100000000}
                                            precision={2}
                                            placeholder={this.props.language["integralPlaceholder"]}
                                            onChange={() => this.props.handelChangeReward()}
                                        />
                                    )}
                                </Form.Item>
                                <Form.Item
                                    labelCol={{ span: 5 }}
                                    wrapperCol={{ span: 19 }}
                                    label={this.props.language["ticket"]}
                                >
                                    {getFieldDecorator('bonus_ticket_id', {
                                        rules: [
                                            {
                                                required: false,
                                                message: this.props.language["ticketVerify"],
                                            },
                                        ],
                                        initialValue: this.props.formData.bonus_ticket_id,
                                    })(
                                        <Select
                                            allowClear
                                            showSearch
                                            optionFilterProp="children"
                                            placeholder={this.props.language["ticketPlaceholder"]}
                                            onChange={() => this.props.handelChangeReward()}
                                        >
                                            {this.props.ticketList.map((item, index) => (
                                                <Select.Option value={item.id} key={index}>
                                                    {item.name}（{item.ticket_value}）（{item.id}）
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                                {getFieldValue('bonus_ticket_id') &&
                                    <Form.Item
                                        labelCol={{ span: 5 }}
                                        wrapperCol={{ span: 19 }}
                                        label={this.props.language["ticketAmount"]}
                                    >
                                        {getFieldDecorator('bonus_ticket_amt', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["ticketAmountVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.bonus_ticket_amt,
                                        })(
                                            <InputNumber
                                                min={1}
                                                max={100000000}
                                                precision={0}
                                                placeholder={this.props.language["ticketAmountPlaceholder"]}
                                            />
                                        )}
                                    </Form.Item>
                                }
                            </Form>
                        )}

                        {/* 编辑排序 */}
                        {this.props.type === "editOrder" && (
                            <Form>
                                <Form.Item label={this.props.language["taskSort"]}>
                                    {getFieldDecorator("order_num", {
                                        rules: [
                                            {
                                                required: true,
                                                message: this.props.language["taskSortVerify"],
                                            },
                                        ],
                                        initialValue: this.props.formData.order_num,
                                    })(
                                        <InputNumber
                                            precision={0}
                                            min={0}
                                            max={999999}
                                            placeholder={this.props.language["taskSortPlaceholder"]}
                                        />
                                    )}
                                </Form.Item>
                            </Form>
                        )}
                    </div>
                </Modal>
            );
        }
    }
);

/**
 * 导入任务表单弹窗
 */
const ImprotFormModal = Form.create({ name: "import_form_model" })(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator } = this.props.form;
            return (
                <Modal
                    maskClosable={false}
                    width={600}
                    title={this.props.title}
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={() => this.props.onCancel("importTask")}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: '70vh',
                        overflowY: "auto",
                    }}
                >
                    <div className="container-content">
                        <Form>
                            <Form.Item label={this.props.language["taskMatchCnfig"]}>
                                {getFieldDecorator("id", {
                                    rules: [
                                        {
                                            required: true,
                                            message: this.props.language["taskMatchCnfigVerify"],
                                        },
                                    ],
                                })(
                                    <Select
                                        loading={this.props.loading}
                                        allowClear
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder={
                                            this.props.language["taskMatchCnfigPlaceholder"]
                                        }
                                    >
                                        {this.props.configList.map((item, index) => (
                                            <Select.Option key={index} value={item.id}>
                                                {item.name}（{item.id}）
                                            </Select.Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </Form>
                    </div>
                </Modal>
            );
        }
    }
);


/**
 * 导入多个任务表单弹窗
 */
const ImprotAllFormModal = Form.create({ name: 'import_all_form_model' })(
    class FormBox extends React.Component {
        /**
         * 上传前
         */
        MAX_SIZE = 10 // 最大上传大小限制
        beforeUpload = (file) => {
            const acceptList = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
            const isAcceptedType = acceptList.includes(file.type)
            if (!isAcceptedType) {
                message.error(this.props.getLanguage("uploadeTypeMessage", 'XLSX'))
                return false
            }
            const isAcceptedLimit = file.size / 1024 / 1024 < this.MAX_SIZE
            if (!isAcceptedLimit) {
                message.error(this.props.getLanguage("uploadeSizeMessage", this.MAX_SIZE))
                return false
            }
            return true
        };

        render () {
            const { getFieldDecorator, getFieldValue } = this.props.form
            return (
                <Modal
                    maskClosable={false}
                    width={600}
                    title={this.props.title}
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={() => this.props.onCancel("importAllConfig")}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: '70vh',
                        overflowY: 'auto'
                    }}
                >
                    <div className="container-content">
                        <Form>
                            <Form.Item label={this.props.language["configFile"]}>
                                {getFieldDecorator('url', {
                                    rules: [
                                        {
                                            required: true,
                                            message: this.props.language["configFileVerify"]
                                        }
                                    ],
                                    initialValue: this.props.importAllformData.url
                                })(
                                    <>
                                        <Upload
                                            name="file"
                                            accept=".xlsx"
                                            listType="text"
                                            disabled={this.props.uploadConfigLoading}
                                            showUploadList={false}
                                            beforeUpload={this.beforeUpload}
                                            customRequest={this.props.handleUploadConfig}
                                        >
                                            {getFieldValue('url') && !this.props.uploadConfigLoading ? (
                                                <Alert style={{ cursor: "pointer" }} message={this.props.uploadConfigFile.name} type="info" />
                                            ) : (
                                                <Button>
                                                    <Icon
                                                        type={this.props.uploadConfigLoading ? 'loading' : 'plus'}
                                                    />
                                                    Upload
                                                </Button>
                                            )}
                                        </Upload>
                                        <div
                                            style={{
                                                fontSize: '14px',
                                                color: '#999'
                                            }}
                                        >
                                            <p>{this.props.getLanguage("suggestSize", this.MAX_SIZE)} </p>
                                        </div>
                                    </>
                                )}
                            </Form.Item>
                        </Form>
                    </div>
                </Modal>
            )
        }
    }
)